window.BSForm={
    data: {
        successMessage: "<i class='fa fa-lg fa-fw fa-check'></i> OK"
    },
    error: ($inputRef,$spanRef,message) => {
        $inputRef
            .closest('.form-group')
            .removeClass("has-success")
            .addClass("has-error");
        $spanRef
            .html(message)
            .css({
                display: "block"
            })
            .removeClass('text-success')
            .addClass('text-danger');
    },
    success: ($inputRef,$spanRef) => {
        $inputRef
            .closest('.form-group')
            .removeClass("has-error")
            .addClass("has-success");
        $spanRef
            .css({
                display: "block"
            })
            .html(BSForm.data.successMessage)
            .removeClass('text-danger')
            .addClass('text-success');
    }
}